t = require('app/scripts/views/internal/teacup-with-helpers')('sync_error')

module.exports = ->
  t.format 'you-have-been-disconnected-from-the-trello-server-for-too-long'
  t.br()
  t.a '.app-alert-item-button', { href: '#', onclick: 'window.location.reload();' }, ->
    t.format 'reload-now'
